export default {
  computed: {
    portalId() {
      return (
        this.$route.params.portalId || this.$store.getters['common/portalId']
      )
    },
  },
}
